import { Setting, SettingType, TServerErrorResponse } from "@/types";
import { http } from "../httpHandler";
import { links } from "@/constants";
import { UserMeetingDomainSetting } from "../../types/user-meeting-domain-setting";

export const USER_GET_SETTINGS = "user-get-settings";
export const USER_MEETING_DOMAIN_SETTINGS = "user-meeting-domain-settings";

export const getUserRecordingSettings = async (userId?: string) => {
  if (!userId) return;
  try {
    const response = await http.get<Setting>(
      links.userRecordingSetting.userRecordingById(userId),
    );

    if (!response.data) {
      return createUserRecordingSettings({ setting: SettingType.ALL });
    }

    return response.data;
  } catch (error) {
    throw error as TServerErrorResponse;
  }
};

// The API derives the owner from the session, so the payload carries no userId.
export const createUserRecordingSettings = async (
  settings: Omit<Setting, "userId">,
) => {
  try {
    const response = await http.post<Setting>(
      links.userRecordingSetting.index,
      settings,
    );

    return response.data;
  } catch (error) {
    throw error as TServerErrorResponse;
  }
};

export const updateUserRecordingSettings = async (
  userId: string,
  settings: Omit<Setting, "userId">,
) => {
  try {
    const response = await http.patch<Setting>(
      links.userRecordingSetting.userRecordingById(userId),
      settings,
    );

    return response.data;
  } catch (error) {
    throw error as TServerErrorResponse;
  }
};

export const getUserMeetingDomainSettings = async (): Promise<UserMeetingDomainSetting[]> => {
  try {
    const response = await http.get<UserMeetingDomainSetting[]>(links.userMeetingDomainSetting.index);
    return response.data;
  } catch (error) {
    throw error as TServerErrorResponse;
  }
};

export const createUserMeetingDomainSetting = async (domain: string, include: boolean = false): Promise<UserMeetingDomainSetting> => {
  try {
    const response = await http.post<UserMeetingDomainSetting>(links.userMeetingDomainSetting.index, { domain, include});
    return response.data;
  } catch (error) {
    throw error as TServerErrorResponse;
  }
};

export const deleteUserMeetingDomainSetting = async (id: string): Promise<void> => {
  try {
    await http.delete<UserMeetingDomainSetting>(links.userMeetingDomainSetting.userMeetingDomainSettingById(id));
  } catch (error) {
    throw error as TServerErrorResponse;
  }
};